export const ProductInterestPrefillFieldsConstant = {
    userId: 'userId',
    customerId: 'customerId',
    product: 'product',
    information: 'information'
};

export const CommunicationPreferencesPrefillFieldsConstant = {
    userId: 'userId',
    email: 'email'
};